module.exports = __webpack_public_path__ + "img/bg-m.b0a58b65.png";